import { CommonModule } from '@angular/common';
import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { isUndefined, toLower } from 'lodash-es';

import { OrderByPipe } from '@wm/components-base';
import { BaseComponent } from '../base/base.component';
import { extractType } from '@wms/core';
import { FieldsListComponent } from '../fields-list/fields-list.component';

@Component({
  selector: 'wms-widget-field-config',
  standalone: true,
  templateUrl: './widget-field-config.component.html',
  styleUrls: ['./widget-field-config.component.less'],
  imports: [
    CommonModule,
    FormsModule,
    OrderByPipe,
    FieldsListComponent
  ],
  host: {class: 'wms-wizard-body-content'}
})
export class WidgetFieldConfigComponent extends BaseComponent implements OnInit {

  @Input() widgetType!: any;
  @Input() currentStep!: any;
  @Input() activeLiveWidget!: any;
  @Input() widgetTypes!: any;
  @Input() fieldTypeWidgetTypeMap!: any;
  @Input() otherWdgts!: any;
  @Input() myWidgets!: any;
  @Input() toggleField!: (field: any) => boolean;
  @Output() selectAllFields = new EventEmitter<any>();
  @Output() updateSelectedComponent = new EventEmitter<any>();
  @Output() updateSelectAll = new EventEmitter<any>();
  @Output() resetDefaultWidgetConfig = new EventEmitter<any>();
  @Output() moveSelectedComponent = new EventEmitter<any>();
  @Output() onWidgetTypeChange = new EventEmitter<any>();
  extractTypefunc = extractType;
  toLowerCase = toLower;
  DIRECTION = {
    'UP': 1,
    'DOWN': 2
  };
  protected isPrism: boolean = false;

  constructor() {
    super();
  }

  ngOnInit(): void {
    this.isPrism = this.projectService.isPrism();
  }

  selectAll(isSelected: boolean) {
    this.selectAllFields.emit(isSelected);
  }

  onRowSelect(field: any, type: string) {
    this.updateSelectedComponent.emit({field, type});
  }

  onColSelect(option: string, col: any, isSelected: boolean) {
    col.pcDisplay = isSelected;
    this.updateSelectAll.emit({option, col});
  }

  moveComponent(direction: any, col: any) {
    this.moveSelectedComponent.emit({direction, col});
  }

  updateFieldName(field: any, type: string, name: string) {
    field.displayName = name;
    this.updateSelectedComponent.emit({field, type});
  }

  onWidgetChange(field: any, widget: any) {
    field.widgetType = widget;
    this.updateSelectedComponent.emit({field, type:'field'});
    this.resetDefaultWidgetConfig.emit();
  }

  updateWidgetTypeChange(field: any, widgetType: any) {
    field.widget = widgetType;
    this.updateSelectedComponent.emit({field, type:'field'});
    this.onWidgetTypeChange.emit(field);
  }

}
